export default {
  setup(target) {
    let listeners = {}

    Object.assign(target, {
      on(type, handler) {
        if (typeof handler == 'function') {
          ;(listeners[type] || (listeners[type] = [])).push(handler)
        }
      },

      off(type, handler) {
        if (arguments.length === 0) {
          listeners = {}
        }
        if (listeners[type]) {
          listeners[type].splice(listeners[type].indexOf(handler) >>> 0, 1)
        }
      },

      offType(type) {
        if (listeners[type]) {
          listeners[type] = []
        }
      },

      fire(type, ...params) {
        // cc.log("all listeners:", listeners)
        ;(listeners[type] || []).slice().map(handler => {
          handler(...params)
          // cc.log(handler.toString())
        })
      },

      removeAllListeners() {
        listeners = {}
      }
    })
  }
}
